export const CategoriesSectionProps = {
  withoutScroll: false,
  placement: 'SearchDropdown',
  customBreakpoints: {
    320: {
      spaceBetween: 10,
      slidesPerView: 1.83,
      centeredSlides: true,
      initialSlide: 0,
    },
  },
};

export const theme = 'Sportscraft';

export const iconSizeProps = { width: '22', height: '22' };
